import React, { Component } from "react";
import { connect } from "react-redux";
import TabsConstants from "../../constants";
import "../../style";
import SubMenu from "../private/SubMenu";
import CounterpartiesView from "./Counterparties/CounterpartiesView";
import Destinations from "./Destinations/Destinations";
import FarmInformationView from "./FarmInformation/FarmInformationView";
import TrucklinesView from "./Trucklines/TrucklinesView";

const CHILD_ROUTES = {
  TRUCKLINES: "trucklines",
  FARMINFORMATION: "farminformation",
  DESTINATIONS: "destinations",
  COUNTERPARTIES: "counterparties"
};
class FarmSetup extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activeTabValue: ""
      //history: null
    };
  }

  componentWillMount() {
    this.setStateBasedOnRoutes(this.props);
  }

  setStateBasedOnRoutes = props => {
    let url = props.route.match.url;
    const params = props.route.match.params;
    const segment0 = Object.keys(params).length > 0 ? params["0"] : null;
    const path = this.props.route.match.path;
    this.setState({ children: path });
    if (segment0 && segment0.indexOf(CHILD_ROUTES.TRUCKLINES) !== -1) {
      this.setState({
        activeTabValue: CHILD_ROUTES.TRUCKLINES,
        children: CHILD_ROUTES.TRUCKLINES
      });
    } else if (segment0 && segment0.indexOf(CHILD_ROUTES.DESTINATIONS) !== -1) {
      this.setState({
        activeTabValue: CHILD_ROUTES.DESTINATIONS,
        children: CHILD_ROUTES.DESTINATIONS
      });
    } else if (
      segment0 &&
      segment0.indexOf(CHILD_ROUTES.COUNTERPARTIES) !== -1
    ) {
      this.setState({
        activeTabValue: CHILD_ROUTES.COUNTERPARTIES,
        children: CHILD_ROUTES.COUNTERPARTIES
      });
    } else {
      this.setState({
        activeTabValue: CHILD_ROUTES.FARMINFORMATION,
        children: CHILD_ROUTES.FARMINFORMATION
      });
    }
  };

  componentWillReceiveProps(props) {
    this.setStateBasedOnRoutes(props);
  }

  render() {
    const { activeTabValue, children } = this.state;
    const { FormSetupScreen } = TabsConstants;
    const menuName = "Farm set up";
    return (
      <div className="">
        <SubMenu
          menuName={menuName}
          tabsVisible={FormSetupScreen}
          routes={this.props.route}
          activeTabValue={activeTabValue}
          handleChangeTabBody={this.updateTabBody}
        />
        <div>
        {children === CHILD_ROUTES.TRUCKLINES && <TrucklinesView />}
        {children === CHILD_ROUTES.FARMINFORMATION && <FarmInformationView />}
        {children === CHILD_ROUTES.DESTINATIONS && <Destinations />}
        {children === CHILD_ROUTES.COUNTERPARTIES && <CounterpartiesView />}
        </div>
      </div>
    );
  }
}
export default connect(
  null,
  {}
)(FarmSetup);



// WEBPACK FOOTER //
// ./src/components/private/FarmSetup.js